import { toast } from "sonner";

const b64ToU8 = (s) => {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const b = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(b, (c) => c.charCodeAt(0));
};

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export async function getPushSubscription() {
  if (!pushSupported()) return null;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    return reg ? await reg.pushManager.getSubscription() : null;
  } catch { return null; }
}

export async function enablePush(client, base, targetUrl) {
  if (!pushSupported()) {
    toast.error("This browser can't show app notifications. On iPhone, install the app to your Home Screen first (iOS 16.4+).");
    return false;
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") {
    toast.error("Notifications are blocked — allow them for this site in your browser settings.");
    return false;
  }
  let reg = await navigator.serviceWorker.getRegistration();
  if (!reg) reg = await navigator.serviceWorker.register("/sw.js");
  reg = await navigator.serviceWorker.ready;
  const { data } = await client.get("/push/vapid-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: b64ToU8(data.key),
    });
  }
  await client.post(`${base}/subscribe`, { subscription: sub.toJSON(), target_url: targetUrl });
  return true;
}

export async function disablePush(client, base) {
  const sub = await getPushSubscription();
  if (sub) {
    try { await client.post(`${base}/unsubscribe`, { endpoint: sub.endpoint }); } catch { /* best-effort */ }
    try { await sub.unsubscribe(); } catch { /* already gone */ }
  }
  return true;
}

export async function snoozePush(client, base, hours) {
  const { data } = await client.post(`${base}/snooze`, { hours });
  return data;
}

export async function pushStatus(client, base) {
  const { data } = await client.get(`${base}/status`);
  return data;
}
